import React from "react";
import CourseCardMini from "./CourseCardMini";
import { Grid, Typography } from "@material-ui/core";

const CourseViews = (props) => {

    return (
        <>
            <Grid container>
                <Typography
                    align="center"
                    style={{
                        fontSize: "32px",
                        color: "#6495ED",
                        fontWeight: "bold",
                        marginBottom: "5px",
                        padding: "10px"
                    }}
                >
                    Course Views
                </Typography>
            </Grid>
            <Grid container>
                {
                    props?.courses?.map((course, i) => {
                        return (
                            <CourseCardMini courseID={course} key={i} />
                        )
                    })
                }
            </Grid>

        </>
    );
}

export default CourseViews;